import React, { useEffect, useRef } from "react";
import { useNavUtils } from "../shared/useNavUtils";
import "./MobileDropdownPopup.scss";

const MobileDropdownPopup: React.FC = (): JSX.Element => {
  const navUtils = useNavUtils();
  const icon = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (icon.current) {
      // @ts-ignore
      $(icon.current).popup({
        hoverable: true,
        inline: true,
        position: "bottom right",
        on: "click",
        lastResort: true,
        delay: {
          hide: 1500,
        },
      });
    }
  }, []);

  const closePopup = (): void => {
    if (icon.current) {
      // @ts-ignore
      $(icon.current).popup("hide");
    }
  };

  return (
    <div className="MobileDropdownPopup">
      <i className="ui chevron circle down big icon" ref={icon} />
      <div className="ui popup">
        <div className="ui list">
          <div
            className="item"
            onClick={() => {
              closePopup();
              navUtils.favorites();
            }}
          >
            <h3>
              <i className="ui heart icon" />
              &nbsp;Favorites
            </h3>
          </div>
          <div className="ui divider" />
          <div
            className="item"
            onClick={() => {
              closePopup();
              navUtils.radio();
            }}
          >
            <h3>
              <i className="ui compact disc icon" />
              &nbsp;Radio
            </h3>
          </div>
          <div className="ui divider" />
          <div
            className="item"
            onClick={() => {
              closePopup();
              navUtils.chordsList();
            }}
          >
            <h3>
              <i className="ui music icon" />
              &nbsp;Chords
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileDropdownPopup;
